var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      class: _vm.bemBlock,
      attrs: {
        "is-open": true,
        "modal-modifier": "pdp-customization-modal",
        "show-backdrop": true
      },
      on: {
        closed: function($event) {
          return _vm.$emit("customize-modal-closed")
        }
      }
    },
    [
      _c("div", { class: _vm.bemElement("content") }, [
        _c(
          "div",
          { class: _vm.bemElement("image") },
          [
            _c("BaseImage", {
              attrs: {
                loading: "eager",
                src: _vm.getDefaultImageUrlFromProductImageSet(_vm.mainImage),
                alt: _vm.getDefaultImageAltFromProductImageSet(_vm.mainImage),
                placeholder: _vm.getPlaceholderImageUrlFromProductImageSet(
                  _vm.mainImage
                ),
                sizes: _vm.imageAttributeSizes.IN_STORE_STOCK,
                srcset: _vm.getSrcsetFromProductImageSet(_vm.mainImage)
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                class: _vm.bemElement("customized-text"),
                style: { color: _vm.customizedColor ? _vm.customizedColor : "" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.customizedText.toUpperCase()) +
                    "\n      "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "h1",
          { class: [_vm.bemElement("title"), "the-product-details__title"] },
          [
            _c("span", { staticClass: "title-text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$msg("customize.modal.title.1", "product")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "title-text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$msg("customize.modal.title.2", "product")) +
                  "\n      "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            ref: "form",
            class: [_vm.bemElement("form"), "form"],
            attrs: {
              id: "customizationForm",
              name: "customizationForm",
              novalidate: ""
            }
          },
          [
            _c("BaseFieldText", {
              ref: "customizeFieldText",
              class: _vm.bemElement("input"),
              attrs: {
                id: "customizeFieldText",
                name: "customizeFieldText",
                autocomplete: "off",
                bem: "the-product-details-customization-modal",
                type: "primary",
                "input-type": "text",
                label: _vm.$msg("customize.modal.input.placeholder", "product"),
                pattern: _vm.azLettersRegex,
                maxlength: 3,
                required: true,
                "error-messages": {
                  patternMismatch: _vm.$msg("error.message.safetext", "forms"),
                  missingError: _vm.$msg("error.message.required", "forms")
                }
              },
              on: { change: _vm.onBaseFieldTextChange },
              model: {
                value: _vm.customizedText,
                callback: function($$v) {
                  _vm.customizedText = $$v
                },
                expression: "customizedText"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.bemElement("colors-wrapper") },
              [
                _c("p", { class: _vm.bemElement("subtitle") }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$msg("customize.modal.color.title", "product")
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("BaseColorSwatches", {
                  class: _vm.bemElement("swatches"),
                  attrs: {
                    bem: "the-product-details-customization-modal",
                    "show-current": true,
                    colors: _vm.product.bylCustomizableColors,
                    "initial-color": _vm.product.bylCustomizableColors[0],
                    "pre-expanded": true
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  _vm.bemElement("add-to-cart"),
                  _vm.bemElement("add-to-cart--desktop"),
                  _vm.bemElement("actions"),
                  "cart-and-ipay",
                  "the-product-details__add-to-cart",
                  "the-product-details__actions"
                ]
              },
              [
                _c("input", {
                  staticClass: "add-to-cart-url",
                  attrs: { type: "hidden" },
                  domProps: { value: _vm.addToCartUrl }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: [
                      _vm.bemElement("add-to-cart-btn", ["desktop"]),
                      "the-product-details__add-to-cart-btn",
                      "the-product-details__add-to-cart-btn--desktop",
                      "add-to-cart",
                      "btn",
                      "btn-primary",
                      "btn-big",
                      "interaction--add-to-bag"
                    ],
                    attrs: {
                      type: "button",
                      "data-pid": _vm.product.id,
                      "data-toggle": "modal",
                      "data-target": "#chooseBonusProductModal",
                      "data-interaction": "interaction--add-to-bag",
                      "data-interaction-state": _vm.isValid
                        ? _vm.STATE_ADD_TO_BAG.ENABLED
                        : _vm.STATE_ADD_TO_BAG.DISABLED
                    }
                  },
                  [
                    _c("BaseSpinner", { attrs: { small: "" } }),
                    _vm._v(" "),
                    _c("span", { staticClass: "default-content" }, [
                      _vm._v(_vm._s(_vm.$msg("button.addtocart", "product")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "swap-content" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$msg("text.alert.addedtobasket", "product")
                          ) +
                          "\n          "
                      )
                    ])
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("p", { class: _vm.bemElement("conditions") }, [
          _c("span", [
            _vm._v(
              " " +
                _vm._s(_vm.$msg("customize.modal.conditions.1", "product")) +
                " "
            )
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              " " +
                _vm._s(_vm.$msg("customize.modal.conditions.2", "product")) +
                " "
            )
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              " " +
                _vm._s(_vm.$msg("customize.modal.conditions.3", "product")) +
                " "
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            class: [
              _vm.bemElement("add-to-cart-btn", "mobile"),
              _vm.bemElement("add-to-cart--mobile"),
              _vm.bemElement("actions"),
              "the-product-details__add-to-cart-btn",
              "the-product-details__add-to-cart-btn--mobile",
              "the-product-details__actions",
              "add-to-cart-mobile",
              "btn",
              "btn--round-black-mobile",
              "interaction--add-to-bag-mobile",
              { disabled: !_vm.isValid }
            ],
            attrs: {
              "data-pid": _vm.product.id,
              "data-size-type": "one-size",
              "data-attr-url": _vm.addToCartUrlMobile,
              "data-toggle": "modal",
              "data-target": "#chooseBonusProductModal",
              "data-interaction": "interaction--add-to-bag-mobile",
              "data-interaction-state": _vm.isValid
                ? _vm.STATE_ADD_TO_BAG_MOBILE.ENABLED
                : _vm.STATE_ADD_TO_BAG_MOBILE.DISABLED
            }
          },
          [
            _c("BaseSpinner", { attrs: { small: "", white: "" } }),
            _vm._v(" "),
            _c("span", { staticClass: "default-content" }, [
              _c("span", { staticClass: "one-size" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$msg("button.addtocart", "product")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "swap-content" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$msg("text.alert.addedtobasket.modal", "product")
                  ) +
                  "\n      "
              )
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }